// Polyfill for IE11
(function () {
	if ( typeof window.CustomEvent === 'function' ) return false;

	function CustomEvent ( event, params ) {
		params = params || { bubbles: false, cancelable: false, detail: undefined };
		var evt = document.createEvent('CustomEvent');
		evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
		return evt;
	}

	CustomEvent.prototype = window.Event.prototype;

	window.CustomEvent = CustomEvent;
})();

const event = {
	/**
	 * Trigger custom event
	 * @param {Element} elems - Element(s) to trigger event
	 * @param {String} eventName - Event to be triggered
	 */
	trigger: (elem, eventName) => {
		const event = new CustomEvent(eventName, {
			bubbles: true,
			cancelable: true
		});

		elem.dispatchEvent(event);
	}
}

export { event };
